import { NamespaceInterface } from '@vendasta/embeddings';

import { Namespace } from './types';

/** True when two namespaces refer to the same entity (by id within a kind, or both admin/global). */
export function namespacesEqual(a: NamespaceInterface, b: NamespaceInterface): boolean {
  if (a.accountGroupNamespace?.accountGroupId && b.accountGroupNamespace?.accountGroupId) {
    return a.accountGroupNamespace.accountGroupId === b.accountGroupNamespace.accountGroupId;
  }
  if (a.partnerNamespace?.partnerId && b.partnerNamespace?.partnerId) {
    return a.partnerNamespace.partnerId === b.partnerNamespace.partnerId;
  }
  if (a.adminNamespace && b.adminNamespace) return true;
  return false;
}

/**
 * Stable membership key for a KB. Knowledge bases are unique by namespace + id — not by name, and not
 * by id alone (ids are namespace-scoped, so a granted KB can collide with an owned one on either). All
 * KB↔source membership matching keys off this instead of the display name.
 */
export function kbIdentityKey(namespace: NamespaceInterface | undefined, id: string | undefined): string {
  const target = namespaceInterfaceToTarget(namespace);
  const nsKey = target ? `${target.type}:${target.id}` : '';
  return `${nsKey}/${id ?? ''}`;
}

export function namespaceInterfaceToTarget(ns: NamespaceInterface | undefined): Namespace | null {
  if (!ns) return null;
  if (ns.accountGroupNamespace?.accountGroupId) {
    return { id: ns.accountGroupNamespace.accountGroupId, type: 'AccountGroup' };
  }
  if (ns.partnerNamespace?.partnerId) {
    return { id: ns.partnerNamespace.partnerId, type: 'Partner' };
  }
  if (ns.adminNamespace) {
    return { id: 'VMF', type: 'Global' };
  }
  return null;
}
